import { useState } from 'react';
import type { EWalletBrand } from '../../../../types/registration-payment.types';
import {
  EWALLET_BRANDS,
  PAYMENT_METHOD_CONFIG
} from '../constants/payment-method.const';
import { PaymentStepLayout } from './PaymentStepLayout';

interface SelectEWalletBrandStepProps {
  initialBrand: EWalletBrand | null;
  onConfirm: (brand: EWalletBrand) => void;
  onBack: () => void;
  isLoading?: boolean;
  noTopMargin?: boolean;
}

export function SelectEWalletBrandStep({
  initialBrand,
  onConfirm,
  onBack,
  isLoading = false,
  noTopMargin = false
}: Readonly<SelectEWalletBrandStepProps>) {
  const [selected, setSelected] = useState<EWalletBrand | null>(initialBrand);

  return (
    <PaymentStepLayout
      backLabel="Payment Method"
      onBack={onBack}
      title="Select an eWallet"
      subtitle="Choose a specific eWallet to proceed further."
      continueDisabled={selected === null}
      onContinue={() => selected && onConfirm(selected)}
      isLoading={isLoading}
      bottomBackLabel="Go back to select Payment Method"
      noTopMargin={noTopMargin}
    >
      {EWALLET_BRANDS.map((brand) => {
        const config = PAYMENT_METHOD_CONFIG[brand];
        const isSelected = selected === brand;
        return (
          <button
            key={brand}
            type="button"
            onClick={() => setSelected(brand)}
            className={`flex w-full items-center justify-between rounded-2xl border-2 p-4 text-left shadow-sm transition-all ${
              isSelected
                ? 'border-[#5CB891] bg-[#f0faf5]'
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <div className="flex items-center gap-3">
              <img
                src={config.logo}
                alt={config.label}
                className="h-10 w-14 rounded-md object-contain"
              />
              <span className="text-sm font-semibold text-gray-900">
                {config.label}
              </span>
            </div>
            <div
              className={`flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border-2 ${
                isSelected ? 'border-[#5CB891]' : 'border-gray-300'
              }`}
            >
              {isSelected && (
                <div className="h-3 w-3 rounded-full bg-[#5CB891]" />
              )}
            </div>
          </button>
        );
      })}
    </PaymentStepLayout>
  );
}
